import type { ComponentProps } from 'react';

import ChevronLeft from '@/public/icons/chevron-left.svg';

export const IconChevronLeft = ({ ...props }: ComponentProps<'svg'>) => {
  return <ChevronLeft {...props} />;
};
